/**
 * Discount Pricing Module - Client-Side Only (SKU-Based)
 * Mirrors Shopify Script logic for EARLY2025 code
 */

(function() {
  'use strict';

  window.Shopify = window.Shopify || {};
  window.DiscountPricing = window.DiscountPricing || {};

  const CONFIG = {
    selectors: {
      collectionPrice: '.price, .price__container',
      originalPrice: '.current_price',
      discountedPrice: '.discount-price',
      comparePrice: '.was_price'
    },
    classes: {
      strikethrough: 'price-strikethrough',
      discountActive: 'discount-active'
    }
  };

  const SKU_DISCOUNT_MAP = {
    '11000528': 20, '11000651': 20, '11005100': 20, '11005528': 20, '11050651': 20, '11085528': 20, '35125651': 20,
    '11075340': 30, '20405340': 30, '20405528': 30, '20410340': 30, '20420340': 30, '20422340': 30, '20436340': 30,
    '35100340': 30, '35100345': 30, '35105340': 30, '35105345': 30, '35110340': 30, '35110345': 30, '35115345': 30,
    '35125333': 30, '35125340': 30, '35130340': 30, '35130345': 30, '35135340': 30, '35135345': 30, '35140340': 30,
    '35140345': 30, '35155340': 30, '35155345': 30, '35170345': 30, '35175340': 30, '35175345': 30, '40131530': 30,
    '40134530': 30, '40135530': 30, '41101530': 30, '41102530': 30, '41103530': 30, '88005703': 30,
    '11000205': 50, '41102231': 50
  };

  const DISCOUNT_CODES = {
    'EARLY2025': { title: 'Early Access 2025', type: 'sku-based' }
  };

  function getDiscountBySku(sku) {
    if (!sku) return null;
    const discount = SKU_DISCOUNT_MAP[sku.toString()];
    return discount !== undefined && discount > 0 ? discount : null;
  }

  function getProductSku(priceElement) {
    let sku = priceElement.dataset.productSku;
    if (!sku) {
      const productElement = priceElement.closest('[data-product-sku]');
      if (productElement) sku = productElement.dataset.productSku;
    }
    return sku || null;
  }

  function formatMoney(cents, format) {
    if (typeof Shopify.formatMoney === 'function' && format) {
      try {
        return Shopify.formatMoney(cents, format);
      } catch (e) {
        console.warn('Shopify.formatMoney failed, using fallback');
      }
    }

    const moneyFormat = format || '${{amount}}';

    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!$))/g, '$1' + thousands);
      const centsStr = parts[1] ? (decimal + parts[1]) : '';
      return dollars + centsStr;
    }

    if (!moneyFormat || typeof moneyFormat !== 'string') {
      return '$' + formatWithDelimiters(cents, 2);
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = moneyFormat.match(placeholderRegex);

    if (!match) {
      return '$' + formatWithDelimiters(cents, 2);
    }

    let value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return moneyFormat.replace(placeholderRegex, value);
  }

  function updatePriceDisplay(priceElement, discountPercent, moneyFormat) {
    try {
      const originalPriceSpan = priceElement.querySelector(CONFIG.selectors.originalPrice);
      const discountedPriceSpan = priceElement.querySelector(CONFIG.selectors.discountedPrice);
      const comparePriceSpan = priceElement.querySelector(CONFIG.selectors.comparePrice);

      if (!originalPriceSpan || !discountedPriceSpan || !comparePriceSpan) return;

      const originalPrice = parseFloat(priceElement.dataset.productPrice);

      if (isNaN(originalPrice) || originalPrice <= 0 || discountPercent === null || discountPercent <= 0) return;

      const discountMultiplier = (100 - discountPercent) / 100;
      const discountedPrice = Math.round(originalPrice * discountMultiplier);

      if (discountedPrice >= originalPrice) return;

      const formattedDiscount = formatMoney(discountedPrice, moneyFormat);

      discountedPriceSpan.textContent = formattedDiscount;
      discountedPriceSpan.style.display = 'inline';
      discountedPriceSpan.style.color = '#d32f2f';
      discountedPriceSpan.style.fontWeight = 'bold';
      discountedPriceSpan.style.marginRight = '8px';
      discountedPriceSpan.classList.add(CONFIG.classes.discountActive);

      comparePriceSpan.innerHTML = originalPriceSpan.innerHTML;
      comparePriceSpan.style.display = 'inline';
      comparePriceSpan.style.textDecoration = 'line-through';
      comparePriceSpan.style.opacity = '0.7';
      comparePriceSpan.classList.add(CONFIG.classes.strikethrough);

      originalPriceSpan.style.display = 'none';
      priceElement.classList.add(CONFIG.classes.discountActive);

      const sku = getProductSku(priceElement);
      console.log('DiscountPricing: Price updated', { sku, discount: discountPercent + '%', original: originalPrice, discounted: discountedPrice });
    } catch (error) {
      console.error('DiscountPricing: Error updating price display', error);
    }
  }

  function updateAllPrices(discountCode, moneyFormat) {
    if (!discountCode) return;

    const discount = DISCOUNT_CODES[discountCode];
    if (!discount) {
      console.warn('DiscountPricing: Unknown discount code:', discountCode);
      return;
    }

    console.log('DiscountPricing: Applying discount:', discount.title);

    const allPrices = document.querySelectorAll(CONFIG.selectors.collectionPrice);
    console.log('DiscountPricing: Found price containers:', allPrices.length);

    let updatedCount = 0;
    let skippedCount = 0;

    allPrices.forEach((priceElement) => {
      const sku = getProductSku(priceElement);

      if (!sku) {
        skippedCount++;
        return;
      }

      const discountPercent = getDiscountBySku(sku);

      if (discountPercent !== null) {
        updatePriceDisplay(priceElement, discountPercent, moneyFormat);
        updatedCount++;
      } else {
        skippedCount++;
      }
    });

    // Toggle banners - show discount banner, hide regular
    document.querySelectorAll('[data-discount-banner]').forEach(banner => {
      banner.style.display = 'block';
    });
    document.querySelectorAll('.sale_banner:not([data-discount-banner])').forEach(banner => {
      banner.style.display = 'none';
    });

    console.log('DiscountPricing: Complete', { updated: updatedCount, skipped: skippedCount });
  }

  function init() {
    console.log('DiscountPricing: Initializing...');

    try {
      let moneyFormat = Shopify.money_format;

      if (!moneyFormat) {
        console.warn('DiscountPricing: Shopify.money_format not set, using fallback');
        moneyFormat = '${{amount}}';
      }

      const urlParams = new URLSearchParams(window.location.search);
      let discountCode = urlParams.get('discount');

      if (discountCode) {
        sessionStorage.setItem('active_discount_code', discountCode);
        console.log('DiscountPricing: Discount from URL:', discountCode);
      } else {
        discountCode = sessionStorage.getItem('active_discount_code');
        if (discountCode) {
          console.log('DiscountPricing: Discount from session:', discountCode);
        }
      }

      if (discountCode) {
        setTimeout(() => {
          updateAllPrices(discountCode, moneyFormat);
        }, 100);
      }
    } catch (error) {
      console.error('DiscountPricing: Init error', error);
    }
  }

  DiscountPricing.init = init;
  DiscountPricing.getDiscountBySku = getDiscountBySku;
  DiscountPricing.updateAllPrices = updateAllPrices;
  DiscountPricing.SKU_DISCOUNT_MAP = SKU_DISCOUNT_MAP;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }

})();
